// React
import { memo, useCallback } from "react";

// Servisni sloj
import {
  clearImpersonation,
  getImpersonatedByName,
  getImpersonatedUserName,
  isImpersonating,
} from "services/auth/impersonation";
import { signOutOnServer } from "services/auth/api";
import { clearSessionAccessToken } from "services/auth/services";

// Moduli specifični za projekt
import { Routes as PublicRoutes } from "ui/modules/public/navigation";

/**
 * Traka koja stoji dok je sesija preuzeta.
 *
 * Ovlasti su pune, kao da je korisnik sam prijavljen, pa mora biti očito u čijem se računu
 * radi. Bez ove trake se lako zaboravi i nešto promijeni klijentu.
 */
const ImpersonationBar: React.FC = () => {
  const handleExit = useCallback(async () => {
    // Prvo poslužitelj: bez toga refresh token ostaje valjan i sesija se može nastaviti.
    try {
      await signOutOnServer();
    } catch {
      // Ako poziv ne prođe, lokalno čišćenje se svejedno mora dogoditi.
    }

    clearImpersonation();
    // Samo ova kartica: trajna prijava djelatnika u drugim karticama ostaje.
    clearSessionAccessToken();

    // Puno učitavanje, ne router: sesija se gasi u cijelosti, zajedno sa stanjem u memoriji.
    window.location.href = PublicRoutes.LoginPage;
  }, []);

  if (!isImpersonating()) return null;

  const userName = getImpersonatedUserName();
  const byName = getImpersonatedByName();

  return (
    <div className="flex items-center justify-between gap-4 px-4 py-2 bg-amber-500 text-white">
      <p className="text-sm">
        Prijavljeni ste kao <span className="font-semibold">{userName || "korisnik"}</span>
        {byName && <> · preuzeo {byName}</>}
      </p>

      <button
        type="button"
        onClick={handleExit}
        className="text-sm font-semibold underline whitespace-nowrap"
      >
        Izađi
      </button>
    </div>
  );
};

export default memo(ImpersonationBar);
